import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Home from '../../../pages/home/home.component';
import Logout from '../../logout/logout.component';
import ProtectedHeader from '../protected-header/protected-header.componenet';
import ProtectedFooter from '../protected-footer/protected-footer.componenet';
import LoggedInTest from '../../../pages/log-in/logged-in-test';
import ProtectedRoute from '../protected-route/protected-route.componenet';
import DetailPrintDisplay from '../../../pages/detail-print/detail-print-display.component';

import CompanyList from '../../../pages/company/company-list/companies-list.component';
import CompanyForm from '../../../pages/company/company-form/company-form.component';

import HelpCategoriesList from '../../../pages/help-category/help-category-list/help-categories-list.component';
import HelpCategoryForm from '../../../pages/help-category/help-category-form/help-category-form.component';
import HelpArticlesList from '../../../pages/help-article/help-article-list/help-articles-list.component';
import HelpArticleForm from '../../../pages/help-article/help-article-form/help-article-form.component';
import HelpUpdatesList from '../../../pages/help-update/help-update-list/help-updates-list.component';
import HelpUpdateForm from '../../../pages/help-update/help-update-form/help-update-form.component';
import HelpOnboardingStepsList from '../../../pages/help-onboarding-step/help-onboarding-step-list/help-onboarding-steps-list.component';
import HelpOnboardingStepForm from '../../../pages/help-onboarding-step/help-onboarding-step-form/help-onboarding-step-form.component';

import AccessDenied from '../../../pages/access-denied/access-denied.component';


const ProtectedLayout = ({
    noNavs
}) => <>
        {!noNavs && <ProtectedHeader />}
        <Switch>
            <ProtectedRoute exact path="/home" component={Home} appName={false} />
            <ProtectedRoute exact path="/logout" component={Logout} />
            <Route path='/access-denied' component={AccessDenied} />
       
            <ProtectedRoute exact path="/loggedintest" component={LoggedInTest} />
            <ProtectedRoute exact path="/detail-print" component={DetailPrintDisplay} />
           
            <ProtectedRoute exact path="/companies" component={CompanyList} key={Date.now()} appName={`company`} />
            <ProtectedRoute exact path="/companies/new" component={CompanyForm} key={Date.now()} isNew={true} appName={`company`} />
            <ProtectedRoute exact path="/companies/:uuid" component={CompanyForm} key={Date.now()} appName={`company`} />

            <ProtectedRoute exact path="/help-categories" component={HelpCategoriesList} key={Date.now()} appName={`helpcategory`} />
            <ProtectedRoute exact path="/help-categories/new" component={HelpCategoryForm} key={Date.now()} isNew={true} appName={`helpcategory`} />
            <ProtectedRoute exact path="/help-categories/:uuid" component={HelpCategoryForm} key={Date.now()} appName={`helpcategory`} />

            <ProtectedRoute exact path="/help-articles" component={HelpArticlesList} key={Date.now()} appName={`helparticle`} />
            <ProtectedRoute exact path="/help-articles/new" component={HelpArticleForm} key={Date.now()} isNew={true} appName={`helparticle`} />
            <ProtectedRoute exact path="/help-articles/:uuid" component={HelpArticleForm} key={Date.now()} appName={`helparticle`} />

            <ProtectedRoute exact path="/help-updates" component={HelpUpdatesList} key={Date.now()} appName={`helpupdate`} />
            <ProtectedRoute exact path="/help-updates/new" component={HelpUpdateForm} key={Date.now()} isNew={true} appName={`helpupdate`} />
            <ProtectedRoute exact path="/help-updates/:uuid" component={HelpUpdateForm} key={Date.now()} appName={`helpupdate`} />

            <ProtectedRoute exact path="/help-onboarding-steps" component={HelpOnboardingStepsList} key={Date.now()} appName={`helponboardingstep`} />
            <ProtectedRoute exact path="/help-onboarding-steps/new" component={HelpOnboardingStepForm} key={Date.now()} isNew={true} appName={`helponboardingstep`} />
            <ProtectedRoute exact path="/help-onboarding-steps/:uuid" component={HelpOnboardingStepForm} key={Date.now()} appName={`helponboardingstep`} />
        </Switch>
        {!noNavs && <ProtectedFooter />}
    </>

export default ProtectedLayout;